import { SystemField } from "./system-field";
export class Property extends SystemField{
    
    code?:string;
    is_active?:number;
    is_multi?:number;
    recordtype_id?:string;
    recordtype_name?:string;
    ordering?:number;
    category_id?:string;
    icon?:string;
    image?:string;
    langs?:any = {en : new PropertyTranslation()};
}
export class PropertyTranslation extends SystemField{
    
    lang_code?:string;
    name?:string;
    properties_id?:string;
    value_options?:string;
    note?:string;
}